// Legacy MG component - invite pipeline functionality has been removed
export function InvitePipeline() {
  return null;
}
